import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, LATEST_JOBS, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${LATEST_JOBS}?perPageCount=6`; 

export const fetchLatestJobList = async () => {
  const url = `${API_BASE_URL}`; 
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};